import { render, staticRenderFns } from "./updatePhoneModal.vue?vue&type=template&id=7fae2856&scoped=true&"
import script from "./updatePhoneModal.vue?vue&type=script&lang=js&"
export * from "./updatePhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./updatePhoneModal.vue?vue&type=style&index=0&id=7fae2856&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fae2856",
  null
  
)

export default component.exports